module.exports = __webpack_public_path__ + "static/media/list-ol-solid.f3ab4a86.svg";